"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: 'start-registration',
    props: {},
    computed: {},
    methods: {},
    components: {},
});
